// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root___avlg","title":"FrontImage_title__3vahl"};